/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  drugsList: [],
  getNdcByMfgId: [],
  getSingleNdcByMfgId: {},
  getNdcGridTableData: '',
  searchByDrugNameTableData: [],
  planViewHistory: [],
  selectByList: '',
  selectList: '',
  errorMessagesInRedux: {},
  getReduxValue: {},
  getReduxValue1: {},
  searchTypeList: '',
  searchScreenData: {},
  getButtonState: true,
  statusBit: 0,
  mfgSelected: {},
  successResponse: {},
  getExitingRow: [],
  CMSUnitTypeDetail: {},
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.FILTER_SEARCH:
      return { ...state, filterValue: action.filterValue };
    case actionTypes.MFG_SELECTED:
      return { ...state, mfgSelected: action.mfgSelected };
    case actionTypes.GET_EXITING_ROW:
      return { ...state, getExitingRow: action.payload };
    case actionTypes.BUTTON_STATE:
      return { ...state, getButtonState: action.payload };
    case actionTypes.SELECTION_TYPE_OPTIONS:
      return { ...state, selectByList: action.payload };
    case actionTypes.SELECT_BY_OPTIONS:
      return { ...state, selectList: action.payload };
    case actionTypes.GET_NDC_MFG_ID:
      return { ...state, getNdcByMfgId: action.payLoad };
    case actionTypes.GET_SINGLE_NDC_MFG_ID:
      return { ...state, getSingleNdcByMfgId: action.payLoad };
    case actionTypes.GET_NDC_GRID_DATA:
      return { ...state, getNdcGridTableData: action.payLoad };
    case actionTypes.SEARCH_TYPE_OPTIONS:
      return { ...state, searchTypeList: action.payload };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_UC:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.SEARCH_REDUX:
      return { ...state, getReduxValue: action.payload };
    case actionTypes.SEARCH_REDUX1:
      return { ...state, getReduxValue1: action.payload };
    case actionTypes.SELECTED_NDC_LIST:
      return { ...state, ndcList: action.ndcList };
    case actionTypes.SEARCH_SELECTED_NDC:
      return { ...state, selectedNdcSearch: action.selectedNdcSearch };
    case actionTypes.GET_ALL_UC_MANUFACTURER_LIST:
      return { ...state, allManufacturer: action.allManufacturer };
    case actionTypes.GET_ALL_UC_EXISTING_ROWS:
      return { ...state, existingRows: action.existingRows };
    case actionTypes.GET_ALL_UC_NDC:
      return { ...state, ndcListForUC: action.ndcListForUC };
    case actionTypes.UPDATED_TABLE:
      return { ...state, updatedTable: action.updatedTable };
    case actionTypes.GET_ALL_UC_LABELER_LIST:
      return { ...state, labelerList: action.labelerList };
    case actionTypes.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA:
      return { ...state, searchByDrugNameTableData: action.payload };
    case actionTypes.NDC_ERROR_POPUP_MESSAGE:
      return { ...state, errorPopupMessage: action.payload };
    case actionTypes.GET_UC_NDC_BY_LABELLER:
      return { ...state, ndcListFromLabeller: action.ndcListFromLabeller };
    case actionTypes.GET_NDCs_UC_LIST_SEARCH_BY_NAME_OR_NDCs:
      return { ...state, drugsList: action.drugsList };
    case actionTypes.ERROR_MSG:
      return { ...state, errorMsg: action.errorMsg };
    case actionTypes.DELETED_NDC:
      if (action?.deleteConvList === 0) {
        return { ...state, deleteConvList: [] };
      }
      // eslint-disable-next-line no-case-declarations
      let updatedState = null;
      if (state?.deleteConvList?.length > 0) {
        updatedState = [action?.deleteConvList, ...state?.deleteConvList];
      } else {
        updatedState = [action?.deleteConvList];
      }

      return {
        ...state,
        deleteConvList: [...updatedState],
      };

    case actionTypes.GET_ALL_REBATE_DROPDOWN: {
      return { ...state, rebateProgramCode: action.rebateProgramCode };
    }
    case actionTypes.GET_ALL_CLAIM_DROPDOWN: {
      return { ...state, claimCode: action.claimCode };
    }

    case actionTypes.VIEW_HISTORY:
      return { ...state, planViewHistory: action.planViewHistory };
    case actionTypes.ERROR_MESSAGES_UC:
      return { ...state, getErrorsFromUC: action.payload };
    case actionTypes.STATUS_BIT:
      return { ...state, statusBit: action.payload };
    case actionTypes.SUCCESS_RESPONSE_DETAIL:
      return { ...state, successResponse: action.payLoad };
    case actionTypes.FIRST_TIME_ADD:
      return { ...state, firstTimeAdd: action.payload };
    case actionTypes.GET_CMS_UNIT_TYPES:
      return { ...state, CMSUnitTypeDetail: action.payload };
    case actionTypes.RESET_UNIT_CONVERSION_DATA:
      return axiosPayLoad;
    default:
      return state;
  }
};

export default reducer;
